import React from 'react';
import { Button } from './ui/Button';
import { FadeIn } from './ui/FadeIn';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-cream py-16 md:py-24 px-4 overflow-hidden relative" data-id="element-59">
      {/* Subtle background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-60">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-beige rounded-full mix-blend-multiply filter blur-3xl opacity-50" data-id="element-61"></div>
        <div className="absolute top-1/2 -left-24 w-72 h-72 bg-terracotta rounded-full mix-blend-multiply filter blur-3xl opacity-10" data-id="element-62"></div>
      </div>

      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-63">
        <FadeIn data-id="element-64">
          <div className="text-center lg:text-left" data-id="element-65">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-66">
              Recupera tu cintura y tu energía:{' '}
              <span className="text-terracotta italic" data-id="element-67">
                El Protocolo Anti-Inflamación de 72 Horas
              </span>
            </h1>
            <p className="text-xl md:text-2xl mb-8 text-brown-body leading-relaxed" data-id="element-68">
              El sistema exacto para apagar la "señal de emergencia" de tu
              cuerpo, deshinchar tu vientre y cerrar ese pantalón antes del
              lunes.
            </p>
            <Button onClick={scrollToOffer} className="w-full sm:w-auto" data-id="element-69">
              ¡QUIERO DESINFLAMARME AHORA!
            </Button>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-70">
          <div className="relative mx-auto max-w-md lg:max-w-full" data-id="element-71">
            <div className="absolute inset-0 bg-beige rounded-3xl transform rotate-3 scale-105 opacity-50" data-id="element-72"></div>
            <img src="https://cdn.magicpatterns.com/uploads/bEPAfrZGqo71zgjbtq1yhp/aZTrlfQB5lXjsVDvfpHic.png" alt="Mujer mirándose al espejo con el vientre inflamado" className="relative z-10 w-full h-auto rounded-3xl shadow-xl object-cover" data-id="element-73" />
          </div>
        </FadeIn>
      </div>
    </section>;
}